let access = [];
let roles = [];
let partners = [];

const publicItems = [
  { type: "menu", name: "login" },
  { type: "menu", name: "logout" }
];

const isPublic = resource =>
  publicItems.find(
    obj => obj.type === resource.type && obj.name === resource.name
  )
    ? true
    : false;

export const EXELOT_PARTNER = 'EXELOT';

export const refreshPermissions = user => {
  const userData = user || JSON.parse(localStorage.getItem("user"));
  if (userData && userData.grants) {
    access = [...userData.grants.effectiveGrants];
    roles = [...userData.grants.effectiveRoles];
    partners = [...userData.partners];
  } else {
    access = [];
    roles = [];
    partners = [];
  }
};

export const isPermitted = resource => {
  if (resource.type) {
    if (isPublic(resource)) {
      return true;
    }
    const names = Array.isArray(resource.name)? [...resource.name]: [resource.name];

    switch (resource.type) {
      case "menu": //ToDo: create the real logic
        return names.reduce((valid, name) => valid || access.indexOf(name) !== -1, false);
      case "resource":
        return names.reduce((valid, name) => valid || !!access.find(_ => _.resource.find(r => r === name)), false);
      case "role":
        return names.reduce((valid, name) => valid || roles.indexOf(name) !== -1, false);
        // return roles.indexOf(resource.name) !== -1;
      case "partner":
        return names.reduce((valid, name) => valid || partners.indexOf(name) !== -1, false);
        // return partners.indexOf(resource.name) !== -1;
      default:
        return false;
    }
  }
  return false;
};

export const getPartners = () => {
  refreshPermissions();
  return partners;
};

export const isAnyPermitted = resources =>
  resources.find(obj => isPermitted(obj)) ? true : false;

